import { Subject } from 'rxjs/Subject';

export class FiltroPaisService {

	private filtrarPais = new Subject<any>();

	notifyObservable$ = this.filtrarPais.asObservable();

  constructor() { }

  public notificarCambiosPais(data: any){
  	if(data){
  		this.filtrarPais.next(data);
  	}
  }
}